import React from 'react';
import Content from '../Content';

const BreadCrumb = ({ crumbs, extraClass }) => (
  <nav className={`breadcrumbs ${extraClass ? extraClass : ''}`}>
      <ul>
          {
            crumbs.map(i => (
              i.url
                ? (<li><a href={i.url}>{i.content}</a></li>)
                : (<li>{i.content}</li>)
            ))
          }
      </ul>
  </nav>
);

export default BreadCrumb;
